<div [ngClass]="{'publishing': publishing}" class="publisher" #publisherDiv1></div>
<a id="lnkClose" class="grid-link" (click)="closeVideo()">
    <i class="fas fa-times video-close" aria-hidden="true"></i>
</a>
<!-- <a *ngIf="!isAudioOnly" id="audio-common" class="grid-link" (click)="audio()">
    <img class="audio-icon" src="../../assets/headphones.png" alt="image" />
</a>
<a *ngIf="isAudioOnly" id="video-common" class="grid-link" (click)="video()">
    <img class="video-icon" src="../../assets/video-camera.png" alt="image" />
</a> -->
<app-msg-box #msgbox></app-msg-box>